import apiClient from "../client.js";

import { API_URLS } from "../urls.js";

export const getProperties = () =>
  apiClient.get(API_URLS.PROPERTIES.ALL_PROPERTIES).then((res) => res.data);

export const getAllPropertiesOptions = ()=>   apiClient.get(API_URLS.PROPERTIES.ALL_PROPERTIES_OPTIONS).then((res) => res.data);

export const getProperty = (id) =>
  apiClient.get(API_URLS.PROPERTIES.DETAIL(id)).then((res) => res.data);

export const createProperty = (agentId, data) =>
  apiClient
    .post(API_URLS.PROPERTIES.CREATE(agentId), data)
    .then((res) => res.data);

export const getPropertiesByAgent = (agentId) =>
  apiClient
    .get(API_URLS.PROPERTIES.LIST_BY_AGENT(agentId))
    .then((res) => res.data);

export const getPropertyByAgent = (agentId, propertyId) =>
  apiClient
    .get(API_URLS.PROPERTIES.DETAIL_BY_AGENT(agentId, propertyId))
    .then((res) => res.data);

export const updateProperty = (agentId, propertyId, data) =>
  apiClient
    .patch(API_URLS.PROPERTIES.UPDATE(agentId, propertyId), data)
    .then((res) => res.data);

export const deleteProperty = (agentId, propertyId) =>
  apiClient
    .delete(API_URLS.PROPERTIES.DELETE(agentId, propertyId))
    .then((res) => res.data);

export const togglePropertyStatus = (agentId, propertyId) =>
  apiClient
    .patch(API_URLS.PROPERTIES.STATUS(agentId, propertyId))
    .then((res) => res.data);

  export const extractPdfData = (data) =>
    apiClient
      .post(API_URLS.PROPERTIES.EXTRACT_PDF_DATA, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res);


  export const extractFloorPlanData = (data) =>
    apiClient
      .post(API_URLS.PROPERTIES.EXTRACT_FLOOR_PLAN, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res);
